import { TdMessageProps } from './type';

export const messageDefaultProps: TdMessageProps = { closeBtn: undefined, duration: 3000, icon: true, theme: 'info' };
